import React from 'react';
import ReactDOM from 'react-dom';
import CommentsContainer from '../comments/CommentsContainer';
import Spinner from '../spinner/Spinner';

//Componentes

//Estilos
import './Help.css';
import './HelpMediaQueries.css';

function Help({ functions, states }) {
    const { loader, isOpen, helpText } = states;
    const { onClose } = functions;

    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div className="help-background">
            <div className="help-container">
                {loader ? (
                    <Spinner />
                ) : (
                    <>
                        <header className="help-header">
                            <button
                                className="modal-close_button"
                                onClick={onClose}
                            >
                                X
                            </button>
                            <h4 className="help-title">Ayuda</h4>
                        </header>
                        <main
                            className="help-main"
                            dangerouslySetInnerHTML={{ __html: helpText }}
                        ></main>
                        <footer className="help-footer">
                            <CommentsContainer />
                        </footer>
                    </>
                )}
            </div>
        </div>,
        document.getElementById('drawer')
    );
}

export default Help;
